var classes = {
  "card": "m_9dc8ae12"
};
export { classes as default };